

function addPlugins(config, slot_name, plugins) {
  if (slot_name in config.pluginSlots === false) {
    config.pluginSlots[slot_name] = {
      keepDefault: true,
      plugins: []
    };
  }

  config.pluginSlots[slot_name].plugins.push(...plugins);
}

async function setConfig () {
  let config = {
    pluginSlots: {}
  };

  try {
    /* We can't assume FPF exists, as it's not declared as a dependency in all
     * MFEs, so we import it dynamically. In addition, for dynamic imports to
     * work with Webpack all of the code that actually uses the imported module
     * needs to be inside the `try{}` block.
     */
    const { DIRECT_PLUGIN, PLUGIN_OPERATIONS } = await import('@openedx/frontend-plugin-framework');
    if (process.env.APP_ID == 'authn') {
    }
    if (process.env.APP_ID == 'authoring') {// frontend-plugin-bulk-rerun exports a component for this authoring MFE slot;
// it is intentionally initialized here instead of registered as a separate MFE.
const { BulkRerunsTab } = await import(
  './plugins/bulk-rerun/src/index.tsx'
);

config.pluginSlots['org.cucwd.frontend.authoring.studio_home_bulk_reruns.v1'] = {
  keepDefault: false,
  plugins: [
    {
      op: PLUGIN_OPERATIONS.Insert,
      widget: {
        id: 'bulk_reruns_tab',
        type: DIRECT_PLUGIN,
        priority: 50,
        RenderWidget: BulkRerunsTab,
      },
    },
  ],
};
const {
  UnitEstimatedTimeEditor,
} = await import('@openedx/estimated-time-to-complete');
      addPlugins(config, 'org.openedx.frontend.authoring.course_unit_sidebar.v2', [
            {
              op: PLUGIN_OPERATIONS.Insert,
              widget: {
                id: 'estimated-time-unit-sidebar-editor-alias',
                priority: 60,
                type: DIRECT_PLUGIN,
                RenderWidget: UnitEstimatedTimeEditor,
              },
            }]);
    }
    if (process.env.APP_ID == 'account') {
    }
    if (process.env.APP_ID == 'communications') {
    }
    if (process.env.APP_ID == 'discussions') {
    }
    if (process.env.APP_ID == 'gradebook') {
    }
    if (process.env.APP_ID == 'learner-dashboard') {// Tutor concatenates runtime definitions from every enabled learner-dashboard
// plugin into one env.config scope. Use a plugin-specific alias so this import
// does not redeclare `reduxHooks` when another plugin imports the same hooks.
const { reduxHooks: courseCardReduxHooks } = await import('hooks');

const CourseRunMetadata = ({ cardId }) => {
  const courseRun = courseCardReduxHooks.useCardCourseRunData(cardId);

  if (!courseRun?.courseId) {
    return null;
  }

  const segments = courseRun.courseId.split('+');
  const courseRunName = segments.length >= 3
    ? segments[segments.length - 1]
    : null;

  return ` • ${courseRunName}`;
};
      addPlugins(config, 'org.openedx.frontend.learner_dashboard.course_card_metadata.v1', [
    {
        op: PLUGIN_OPERATIONS.Insert,
        widget: {
            id: 'courserun_metadata',
            type: DIRECT_PLUGIN,
            priority: 60,
            RenderWidget: CourseRunMetadata,
        },
    }
    ]);
    }
    if (process.env.APP_ID == 'learning') {
    }
    if (process.env.APP_ID == 'ora-grading') {
    }
    if (process.env.APP_ID == 'profile') {
    }
    if (process.env.APP_ID == 'learner-record') {
    }
  } catch (err) { console.error("env.config.jsx failed to apply: ", err);}

  return config;
}

export default setConfig;